import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DeleteDeposit, DoDeposit, GetDepositList, GetEventList } from '../../common/actions/moreAction';
import { convertDepositString, convertStyle, dateFormation, isEmpty, isMobilePage, moneyValues, no_comma } from '../../common/cores';
import Pagenation from '../common/Pagenation';
import NavLink from 'react-router-dom/NavLink';
const MainContent = (props) => {

    const [money, setMoney] = useState(0);
    const [showHis, setShowHis] = useState(false);

    const lists = props.deposit.data;
    const { page, user } = props;
    const [ids, setIds] = useState([]);

    const getLists = (page) => {
        props.GetDepositList("deposit", page);
    }


    const onChange = (e) => {
        const { value, checked } = e.target; // 우선 e.target 에서 name 과 value 를 추출
        // console.log(value, checked)
        if (checked) setIds([...ids, value]);
        else setIds(ids.filter(item => item !== value))
        // console.log(ids);
        // console.log(isNaN(Number(value)))
        if (!isNaN(Number(no_comma(value))))
            setMoney(Number(no_comma(value)));
        else setMoney(0);
    };

    useEffect(() => {
        getLists(1);
    }, [props.page.perPage])

    const reset = () => {
        setMoney(0);
    }

    const historyDelete = (value) => {
        console.log(value);
        props.DeleteDeposit({
            ids,
            all: value,
            typeStr: 'deposit'
        })
    }
    const moneyValues = [
        {
            value: 10000,
        },
        {
            value: 30000,
        },
        {
            value: 50000,
        },
        {
            value: 100000,
        },
        {
            value: 500000,
        },
        {
            value: 1000000,
        },
        {
            value: 5000000,
        },
        {
            value: 10000000,
        },
    ]

    const showHisotry = () => {
        setShowHis(!showHis);
    }
    const getMoneyFormat = (val) => {
        let res = "";
        if (val / 10000 > 0)
            res += (val / 10000) + "만원"
        val = val % 10000;
        if (val / 1000 > 0)
            res += (val / 1000) + "천원"
        val = val % 1000;
        if (val / 100 > 0)
            res += (val / 100) + "백원"
        val = val % 100;
        if (val / 10 > 0)
            res += (val / 10) + "십원"
        val = val % 10;
        if (val != 0)
            res += val
        return res
    }
    return (
        <div className="mypage_cont">
            <div className="contents_box">
                <div className="con_box00">
                    <div className="tab_wrap">
                        <ul>
                            <li><NavLink to="/deposit"><span className="tab">{isEmpty(window.lang["입금신청"]) ? "입금신청" : window.lang["입금신청"]}</span></NavLink></li>
                            <li><NavLink to="/deposit/details"><span className="tab">{isEmpty(window.lang["입금내역"]) ? "입금내역" : window.lang["입금내역"]}</span></NavLink></li>

                        </ul>
                    </div>
                </div>
                <div className="con_box10">
                    <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                        <tbody>
                            <tr>
                                <td width="10%" className="list_title1">{isEmpty(window.lang["신청일시"]) ? "신청일시" : window.lang["신청일시"]}</td>
                                <td width="10%" className="list_title1">{isEmpty(window.lang["입금신청 금액"]) ? "입금신청 금액" : window.lang["입금신청 금액"]}</td>
                                <td width="10%" className="list_title1">{isEmpty(window.lang["처리일시"]) ? "처리일시" : window.lang["처리일시"]}</td>
                                <td width="10%" className="list_title1">{isEmpty(window.lang["처리상태"]) ? "처리상태" : window.lang["처리상태"]}</td>
                            </tr>
                            {!isEmpty(lists) &&
                                lists.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="list1">{!isEmpty(item.created_date) && dateFormation(item.created_date)}</td>
                                            <td className="list1"><span className="font06">{!isEmpty(item.amount) && Number(item.amount).toLocaleString()}</span></td>

                                            <td className="list1">{!isEmpty(item.approved_date) && dateFormation(item.approved_date)}</td>
                                            <td className="list1">{!isEmpty(item.status) && <span style={convertStyle(item.status)}>{convertDepositString(item.status)}</span>}</td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>

                </div>
                <Pagenation page={page.curPage}
                    totalPage={page.totalPage}
                    getPage={getLists}
                    perPage={10} />
            </div>
        </div>

    );
};

const mapStateToProps = state => ({
    user: state.user,
    deposit: state.more.deposit,
    page: state.page
})

export default connect(mapStateToProps, { GetDepositList, DoDeposit, DeleteDeposit })(MainContent);


// WEBPACK FOOTER //
// ./src/components/account/depositDetailsContent.js